import { useTranslation } from 'react-i18next';
import { ACCOUNT_TYPES } from '../../constants/constTypes';
import { trackEvent } from '../../utils/common/analytics';

const SITE_HOSTS = ['worldauto.ge', 'localhost'];

const isExternalUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    if (!/^https?:\/\//i.test(url)) return false;
    try {
        const host = new URL(url).hostname;
        return !SITE_HOSTS.some(
            (h) => host === h || host.endsWith(`.${h}`),
        );
    } catch {
        return false;
    }
};

export const Url = ({
    to,
    text,
    className = 'url',
    noTranslate = false,
    trackingData = null,
    ...props
}) => {
    const { t } = useTranslation();

    const handleClick = (e) => {
        const isPhoneLink = to && to.startsWith('tel:');

        if (isPhoneLink) {
            trackEvent('phone_tap', {
                event_category: 'lead_conversion',
                phone_number: to.replace('tel:', ''),
                advert_id: trackingData?.id,
                seller_type: trackingData?.accountType || 'unknown',
                price: trackingData?.price,
                section: trackingData?.typeVehicle || 'unknown',
            });

            if (trackingData && typeof gtag !== 'undefined') {
                const getCallType = (accountType) => {
                    switch (accountType) {
                        case ACCOUNT_TYPES.USER:
                            return ACCOUNT_TYPES.USER;
                        case ACCOUNT_TYPES.DEALER:
                            return ACCOUNT_TYPES.DEALER;
                        case ACCOUNT_TYPES.CORPORATE:
                            return ACCOUNT_TYPES.CORPORATE;
                        default:
                            return 'unknown';
                    }
                };

                gtag('event', 'phone_call_attempt', {
                    event_category: 'lead_conversion',
                    event_label: 'phone_click',
                    item_id: trackingData.id,
                    item_name: `${trackingData.mark} ${trackingData.model}`,
                    value: trackingData.price,
                    currency: 'GEL',
                    phone_number: to.replace('tel:', ''),
                    seller_type: trackingData.accountType,
                    call_type: getCallType(trackingData.accountType),
                });

                gtag('event', 'conversion', {
                    send_to: 'G-41609N9MEY',
                    event_category: 'phone_conversion',
                    transaction_id: `call_${trackingData.id}_${Date.now()}`,
                    value: 1,
                    currency: 'USD',
                });
            }
        } else if (isExternalUrl(to)) {
            try {
                const host = new URL(to).hostname;
                trackEvent('outbound_click', {
                    event_category: 'outbound',
                    link_url: to,
                    link_domain: host,
                });
            } catch {
                /* non-fatal */
            }
        }

        if (props.onClick) {
            props.onClick(e);
        }
    };

    return (
        <a href={to} className={className} {...props} onClick={handleClick}>
            {noTranslate ? text : t(text)}
        </a>
    );
};
